/* eslint-disable @typescript-eslint/default-param-last */
import {
  END_INTERVIEW_FOR_ALL,
  GET_ZOOM_CHAT_HISTORY,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
} from "../constants/ActionTypes";
import initialState from "../store/initialState";
import { IChatType } from "../types/auth.types";

const chatReducer = (state = initialState.chat, action: IChatType) => {
  switch (action.type) {
    case `${GET_ZOOM_CHAT_HISTORY}_SUCCESS`:
      return action.payload;
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.chat;
    default:
      return state;
  }
};

export default chatReducer;
